import React from 'react';
import { motion } from 'framer-motion';
import { Fish, Sparkles, GraduationCap, ShoppingBasket } from 'lucide-react';

const offerings = [
  {
    icon: Fish,
    title: 'Pond Fishing',
    tag: 'Catch & release · Catch & keep',
    desc: 'Stocked ponds with tilapia, bangus, gurami, ayungin, at iba pang mga surprise catch. Bring your gear o rent on-site. Open both half-day and full-day slots.',
  },
  {
    icon: Sparkles,
    title: 'Prawning & Mud Crabbing',
    tag: 'Pinoy bayside thrill',
    desc: 'Manghuli ng sariwang prawns at alimango sa brackish corners ng resort — tense, tactile, at sobrang sulit na huli para sa hapunan. Beginner-friendly, kid-safe with a guide.',
  },
  {
    icon: GraduationCap,
    title: 'Learn-to-Fish',
    tag: 'Beginner lessons',
    desc: '45-minute guided session with a local kuya. Includes rods, bait, and the basics — kahit zero experience.',
  },
  {
    icon: ShoppingBasket,
    title: 'Catch-and-Keep',
    tag: 'Bring home the fresh catch',
    desc: 'Pay per kilo. Mga huli mo, you can grill on-site or take home — vacuum-packed on request.',
  },
];

export default function Offerings() {
  return (
    <section
      id="offerings"
      data-testid="offerings-section"
      className="py-20 md:py-32 bg-offwhite"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mb-14">
          <p className="overline text-muted mb-4">What you can do today</p>
          <h2 className="editorial-display text-pond text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Catch and Discover —
            <br />
            <em className="italic font-light text-moss">Thrill of the Unknown.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {offerings.map((o, i) => {
            const Icon = o.icon;
            return (
              <motion.div
                key={o.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`offering-${o.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                className="group relative p-7 md:p-10 rounded-3xl bg-sand border border-moss/20 hover:border-pond/40 transition-all duration-500 hover:shadow-[0_24px_60px_rgba(26,59,43,0.08)]"
              >
                <div className="flex items-start justify-between gap-6 mb-6">
                  <div className="w-14 h-14 rounded-2xl bg-pond/10 text-pond flex items-center justify-center group-hover:bg-pond group-hover:text-offwhite transition-all duration-500">
                    <Icon className="w-7 h-7" strokeWidth={1.5} />
                  </div>
                  <span className="overline text-muted text-right max-w-[55%]">{o.tag}</span>
                </div>
                <h3 className="editorial-display text-3xl md:text-4xl text-pond leading-tight mb-3">
                  {o.title}
                </h3>
                <p className="text-charcoal/80 text-base md:text-lg leading-relaxed">
                  {o.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
